/* import __COLOCATED_TEMPLATE__ from './lsg-filter-sort.hbs'; */
import { computed } from '@ember/object';
import { A } from '@ember/array';
import Component from '@ember/component';
import { ICON_SORTS } from "../../constants/lsg";

/**
 * Reusable component with two lsg-selects on either side of the screen.  The left select will be called
 * the 'filter' while the right select will be called the 'sort'
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'div',
  classNames: ['LSG-c-filter-sort'],
  classNameBindings: ['isDisabled:is-disabled'],

  /**
   * The placeholder for the filter text select
   *
   * @param {String}
   */
  filterPlaceholderText: 'Select',

  /**
   * The array of options that we'll feed into the lsg-select for the filter on the left side of the screen
   *
   * @see lsg-select.options for the format
   *
   * @param {Ember.MutableArray}
   */
  filterOptions: A(),

  /**
   * The array of options that we'll feed into the lsg-select for the company team filter
   *
   * @see lsg-select.options for the format
   *
   * @param {Array}
   */
  companyTeamFilterOptions: [],

  /**
   * Intended for the caller to get the value of the selected filter through this reference
   *
   * @param {String}
   */
  filterValue: '',

  /**
   * Intended for the caller to get the value of the selected company team filter through this reference
   *
   * @param {String}
   */
  companyTeamFilterValue: '',

  /**
   * True when you want to disable all available filters/sorts
   *
   * @param {Boolean=}
   */
  isDisabled: false,

  /**
   * Set this to false if you don't want to show the filter on the right hand side.
   *
   * @param {Boolean=}
   */
  isShowFilter: true,

  /**
   * The placeholder for the sort text select
   *
   * @param {String}
   */
  sortPlaceholderText: 'Select',

  /**
   * The array of options that we'll feed into the lsg-select for the sort on the right side of the screen
   *
   * @see lsg-select.options for the format
   *
   * @param {Ember.MutableArray}
   */
  sortOptions: A(),

  /**
   * Intended for the caller to get the value of the selected sort through this reference
   *
   * @param {String}
   */
  sortValue: '',

  /**
   * The sort available in the icon piece of the component.
   *
   * Intended to be checked by reference.
   *
   * @param {String}    of type ICON_SORTS.*
   */
  iconSort: ICON_SORTS.SORT_DESCENDING,

  /**
   * True when this is the ascending sort
   *
   * @type {Boolean}
   * @private
   */
  _isAscending: computed('iconSort', function() {
    return this.get('iconSort') === ICON_SORTS.SORT_ASCENDING;
  }),

  /** @param {Function} */
  setOrderValue: () => {},

  /** @param {Function} */
  setSortValue: () => {},

  /**
   * @inheritDoc
   */
  actions: {

    /**
     * Called when button is clicked to toggle the icon sort.
     */
    onToggleIconSort: function() {
      if (!this.get('isDisabled')) {
        this.set(
          'iconSort',
          this.get('iconSort') === ICON_SORTS.SORT_ASCENDING ?
            ICON_SORTS.SORT_DESCENDING :
            ICON_SORTS.SORT_ASCENDING);

        this.setOrderValue(this.iconSort);
      }
    }
  }
});
